module.exports = __webpack_public_path__ + "img/shareimg1.2da81f51.png";